<template>
	<div class="managerapprove">
		<template v-for="headerApp in headerNotiApprove.rows">
			<router-link :to="{ name: headerApp.key }">
	      <div class="block-item">
	        <div class="menu-icon fa" :class="headerApp.option2"><i class="fa" :class="headerApp.option1"></i></div>
	        <div class="menu-codapp">{{ headerApp.key }}</div>
	        
	        <div class="menu-summary summary-" :class="headerApp.key" v-if="headerApp.summary <= 999">{{ headerApp.summary }}</div><div v-else>999+</div>

	        <div class="menu-text">{{ headerApp.values }}</div>
	      </div>
	    </router-link>
    </template>
    <div class="no-pending" v-show="headerNotiApprove.rows.length == 0">{{ labels[dash.nowLang]['no_pending'] }}</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as types from 'store/modules/dash/mutation-types'

export default {
  name: 'manager-approve',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      labels: {
        en: {
          'no_pending': 'No pending records for approval.'
        },
        th: {
          'no_pending': 'ไม่พบรายการที่รอการอนุมัติ'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      headerNotiApprove: types.GET_HEADER_APPROVE
    })
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?876f68cc